import { render, staticRenderFns } from "./ForumAnswerDeletionDialog.vue?vue&type=template&id=42d7ee17"
import script from "./ForumAnswerDeletionDialog.vue?vue&type=script&lang=ts"
export * from "./ForumAnswerDeletionDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports